module.exports = __webpack_public_path__ + "static/img/springAndsummer_baocaiPic.4f14913c.png";